
import {InputFieldContentModel, TextInputFieldContentModel, NumberInputFieldContentModel, SliderInputFieldContentModel, CheckboxInputFieldContentModel, PasswordInputFieldContentModel, RadioInputFieldContentModel, RadioInputFieldOptionContentModel, DropDownInputFieldContentModel, DropDownInputFieldOptionContentModel, TextAreaInputFieldContentModel} from './inputFields/contentmodel';

import {ButtonContentModel, ProgressButtonContentModel} from './buttons/contentmodel';

import {ProgressBarContentModel} from './progress/contentmodel';

import {ControlGroupContentModel, FormContentModel} from './forms/contentmodel';

import {StaticTextContentModel, StaticImageContentModel} from './static/contentmodel';

import {LayoutContentModel, SingleLayoutContentModel, ColumnLayoutContentModel, ColumnsWithTitleLayoutContentModel, RowLayoutContentModel, TableLayoutContentModel} from './layouts/contentmodel';

export const ContentModels = {
	TextInputFieldContentModel: TextInputFieldContentModel,
	NumberInputFieldContentModel: NumberInputFieldContentModel,
	SliderInputFieldContentModel: SliderInputFieldContentModel,
	CheckboxInputFieldContentModel: CheckboxInputFieldContentModel,
	PasswordInputFieldContentModel: PasswordInputFieldContentModel,
	RadioInputFieldContentModel: RadioInputFieldContentModel,
	RadioInputFieldOptionContentModel: RadioInputFieldOptionContentModel,
	DropDownInputFieldContentModel: DropDownInputFieldContentModel,
	DropDownInputFieldOptionContentModel: DropDownInputFieldOptionContentModel,
	//TextAreaInputFieldContentModel: TextAreaInputFieldContentModel,

	ProgressBarContentModel: ProgressBarContentModel,
    ButtonContentModel: ButtonContentModel,
    ProgressButtonContentModel: ProgressButtonContentModel,
	ControlGroupContentModel: ControlGroupContentModel,
	SingleLayoutContentModel: SingleLayoutContentModel,
	ColumnLayoutContentModel: ColumnLayoutContentModel,
	RowLayoutContentModel: RowLayoutContentModel,
	TableLayoutContentModel: TableLayoutContentModel,
	StaticTextContentModel: StaticTextContentModel,
	StaticImageContentModel: StaticImageContentModel,
	FormContentModel: FormContentModel,
};

export const ContentModel = FormContentModel;

//export const InputFieldContentModel = InputFieldContentModel;
//export const LayoutContentModel = LayoutContentModel;

import style from './style.css';

export const description = "Generic form component. This can be connected to an Excel model.";
export const instructions = "";



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/index.js